import Styled from 'styled-components';

export const Line = Styled.div`
	position: relative;
    overflow: hidden;
	height: auto;
`;
export const BottomTwoLevelTableRow = Styled.div`

box-sizing: border-box;
display: flex;
justify-content: stretch;
align-items: center;
height: 40px;
background: white;
padding-left: ${({numberOfParents}) =>
	numberOfParents === 1 ? '48px;' : numberOfParents === 2 ? '92px;' : numberOfParents === 0 && '16px;'}
border-top: ${({isFirstRow}) => (isFirstRow ? 0 : '1px')} solid #e6e6e6;
border-bottom: ${({isExpanded}) => (isExpanded ? '1px' : 0)} solid #e6e6e6;

${props => (props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'z-index:1;' : '')};
${props => (props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'position:sticky;' : '')};
${props => (props.stickyTopPosition !== null && props.stickyTopPosition !== undefined ? 'top: 84px;' : '')};

&:hover {
    cursor: pointer; 
    background-color:#f8f3fe;
}
`;

export const BottomTwoLevelItem = Styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
box-sizing: border-box;
font-size: 13px;
color: #080927;
font-weight: 400;
line-height: normal;

padding-right: 16px;
width: 166px;
height: 100%;
order: ${props => props.order};

span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }

abbr {
    text-decoration: none;
}
`;

export const BottomTwoLevelRightItem = Styled.div`
display: flex;
justify-content: flex-end;
align-items: center;
box-sizing: border-box;
font-size: 13px;
color: #080927;
font-weight: 400;
line-height: normal;
padding-right: 16px;
width: 166px;
height: 100%;
order: ${props => props.order};

span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }
`;

export const BottomTwoLevelGreyItem = Styled(BottomTwoLevelItem)`
color: #a1a1a1;
`;

export const BottomTwoLevelDetailItem = Styled.div`
display:  grid;
flex:1;
box-sizing: content-box;
min-width: 166px;
height: 100%;

padding-right: 16px;
font-size: 13px;
color: #080927;
align-items: center;
order: ${props => props.order};


span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;


        >div {
        display: flex;
        flex: auto;
        justify-content: flex-start;
        align-items: center;
        min-width: 166px;

        >span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }

        p{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }

        }
    }

abbr{
    text-decoration: none;
}


`;

export const BottomTwoSpaceItem = Styled.div`
flex: 1;
box-sizing: border-box;
`;

export const MainItem = Styled.div`
display:  grid;
flex:1;
box-sizing: content-box;
justify-content: flex-start;
min-width: 166px;
height: 100%;
padding-left: 16px;
font-size: 13px;
color: #080927;
align-items: center;
order: ${props => props.order};

span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        

        >div {
        display: flex;
        flex: auto;
        justify-content: flex-start;
        align-items: center;
        min-width: 166px;

        span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }

        p{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        }
    }

    }

abbr{
    text-decoration: none;
}
`;

export const CaretIconWrapper = Styled.div`
box-sizing: border-box;

order: ${props => props.order};
`;
